import BadgesPlayground from './BadgesPlayground'
import ContentBlock from './ContentBlock'
import ContentScroller from './ContentScroller'
import DesktopEmbed from './Demo/DesktopEmbed'
import Hero from './Hero'
import LatestBlogPost from './Blog/LatestPost'
import MobileEmbed from './Demo/MobileEmbed'
import ProfilePicture from './ProfilePicture'
import Signpost from './Signpost'
import Skillset from './Skillset'
import Testimonials from './Testimonials/TestimonialsScroller'
import Testimonial from './Testimonials/Testimonial'
import ProjectBullets from './Project/ProjectBullets'
import ProjectList  from './Project/ProjectList'
import ProjectBrands from './Project/ProjectBrands'
import RelatedProjects from './Project/RelatedProjects'

export { 
    BadgesPlayground,
    ContentBlock,
    ContentScroller,
    DesktopEmbed,
    Hero,
    LatestBlogPost,
    MobileEmbed,
    ProfilePicture,
    ProjectBrands,
    Signpost,
    Skillset,
    ProjectBullets,
    ProjectList,
    RelatedProjects,
    Testimonials,
    Testimonial
}


// WEBPACK FOOTER //
// ./src/components/index.js